import { type CookieAttributes, set } from 'js-cookie';
import { remove } from 'js-cookie';
import { getTopLevelDomain } from '@lingoda/urls';

export { get as getCookieValue } from 'js-cookie';

export const setCookieValue = (name: string, value: string, options?: CookieAttributes) => {
    const domain = getTopLevelDomain();
    const expires = new Date();
    expires.setFullYear(expires.getFullYear() + 1, expires.getMonth(), expires.getDate());
    set(name, value, { domain, expires, ...options });
};

export const removeCookieValue = (name: string, options?: CookieAttributes) => {
    const domain = getTopLevelDomain();
    // if it was set from the marketing website, it will have top level domain.
    remove(name, { domain, ...options });
    // it it was set from the student app, it will have `.learn.` domain and should also be removed
    remove(name, options);
};
